/* FORMA · Pincel: en computador el puntero es un pincel y se puede pintar arrastrando sobre la página.
   - Solo con mouse y pantallas de 990 px o más.
   - Se pinta manteniendo el clic sobre zonas que no son enlaces ni botones.
   - Trazo de pincel: cuerpo de tinta + cerdas, cada una dibujada como una cinta continua de ancho variable
     (sin uniones visibles). Punta que se abre al apoyar y se cierra al levantar, grosor según la velocidad
     (lento = grueso) y tinta que se va secando: las cerdas se cortan y aparecen vetas de pincel seco.
   - La tinta es blanca con mezcla 'difference': negro sobre blanco y blanco sobre negro.
   - Shift + arrastrar selecciona texto como siempre. Esc borra todo. */
(function () {
  'use strict';
  var cfg = document.getElementById('forma-lapiz');
  if (!cfg || (window.Shopify && window.Shopify.designMode)) return;

  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var ANCHO = parseFloat(cfg.dataset.ancho) || 14;
  var ESPERA = (parseFloat(cfg.dataset.borrar) || 0) * 1000; // 0 = el trazo no se borra solo
  var FADE = 1400;
  var SECADO = 1600; // px de recorrido hasta que la tinta llega a su mínimo
  var NO = 'a,button,input,textarea,select,label,summary,iframe,video,[role="button"],[contenteditable],' +
    '.forma-ayuda,.forma-barra,.forma-tallas,cart-drawer,.drawer,.menu-drawer,quick-add-modal,modal-dialog,predictive-search';
  var html = document.documentElement;
  var canvas, ctx, dpr = 1, trazos = [], actual = null, raf = 0, activo = false;

  function crear() {
    canvas = document.createElement('canvas');
    canvas.className = 'forma-lapiz-lienzo';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    medir();
  }
  function medir() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    pedir();
  }
  function pedir() { if (!raf) raf = requestAnimationFrame(pintar); }

  function pintar(now) {
    raf = 0;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    var sx = window.scrollX, sy = window.scrollY, vivos = false;
    trazos = trazos.filter(function (t) {
      var a = 1;
      if (t.fin && ESPERA) {
        var dt = now - t.fin - ESPERA;
        if (dt > 0) a = 1 - dt / FADE;
        if (a <= 0) return false;
        vivos = true;
      }
      dibujar(t, sx, sy, a);
      return true;
    });
    if (vivos || actual) pedir();
  }

  // Cerdas propias de cada trazo: posición a lo ancho, opacidad, grosor y en qué punto se secan.
  function cerdas() {
    var b = [];
    for (var k = 0; k < 9; k++) {
      b.push({
        o: (k / 8 - 0.5) * 0.9 + (Math.random() - 0.5) * 0.06,
        a: 0.35 + Math.random() * 0.5,
        s: 0.08 + Math.random() * 0.12,
        seca: 0.25 + Math.random() * 0.5
      });
    }
    return b;
  }

  function normales(p) {
    var n = p.length, N = [];
    for (var i = 0; i < n; i++) {
      var a = p[Math.max(0, i - 1)], b = p[Math.min(n - 1, i + 1)];
      var dx = b.x - a.x, dy = b.y - a.y, L = Math.hypot(dx, dy) || 1;
      N.push({ x: -dy / L, y: dx / L });
    }
    return N;
  }

  function recorrer(P, mover) {
    if (mover) ctx.moveTo(P[0][0], P[0][1]); else ctx.lineTo(P[0][0], P[0][1]);
    for (var i = 1; i < P.length - 1; i++) {
      ctx.quadraticCurveTo(P[i][0], P[i][1], (P[i][0] + P[i + 1][0]) / 2, (P[i][1] + P[i + 1][1]) / 2);
    }
    ctx.lineTo(P[P.length - 1][0], P[P.length - 1][1]);
  }

  // Dibuja una cinta continua: centro desplazado y medio ancho distintos en cada punto.
  function cinta(p, N, W, sx, sy, fn) {
    var izq = [], der = [];
    for (var i = 0; i < p.length; i++) {
      var r = fn(i, W[i]), c = r[0], h = r[1];
      izq.push([p[i].x + N[i].x * (c + h) - sx, p[i].y + N[i].y * (c + h) - sy]);
      der.push([p[i].x + N[i].x * (c - h) - sx, p[i].y + N[i].y * (c - h) - sy]);
    }
    ctx.beginPath();
    recorrer(izq, true);
    recorrer(der.reverse(), false);
    ctx.closePath();
    ctx.fill();
  }

  function dibujar(t, sx, sy, a) {
    var p = t.p, n = p.length;
    ctx.fillStyle = '#fff';
    if (n < 3) {
      ctx.globalAlpha = a * 0.85;
      ctx.beginPath();
      ctx.arc(p[0].x - sx, p[0].y - sy, ANCHO * 0.28, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
      return;
    }
    var N = normales(p), W = [], T = [];
    for (var i = 0; i < n; i++) {
      var punta = Math.min(1, (i + 0.5) / 7);                 // la punta se abre al apoyar el pincel
      if (t.fin) punta = Math.min(punta, (n - 1 - i) / 7);    // y se cierra al levantarlo
      W.push(p[i].w * Math.max(0, punta));
      T.push(Math.max(0.2, 1 - p[i].d / SECADO));             // tinta disponible en ese punto
    }
    // Cuerpo de tinta: se angosta a medida que se seca
    ctx.globalAlpha = a * 0.92;
    cinta(p, N, W, sx, sy, function (i, w) { return [0, w * 0.3 * Math.pow(T[i], 0.9)]; });
    // Cerdas: textura del borde; cuando la tinta baja de su umbral, la cerda casi desaparece (veta seca)
    for (var k = 0; k < t.b.length; k++) {
      var c = t.b[k];
      ctx.globalAlpha = a * c.a;
      cinta(p, N, W, sx, sy, function (i, w) {
        var seco = T[i] > c.seca ? 1 : Math.max(0.12, T[i] / c.seca * 0.4);
        return [c.o * w, Math.max(0.3, w * c.s) * seco];
      });
    }
    ctx.globalAlpha = 1;
  }

  function bloqueado(el) { return !el || !el.closest || !!el.closest(NO); }

  function abajo(e) {
    if (!activo || e.button !== 0 || e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;
    if (bloqueado(e.target) || document.body.classList.contains('overflow-hidden')) return;
    e.preventDefault();
    actual = { p: [{ x: e.pageX, y: e.pageY, w: ANCHO * 0.7, t: e.timeStamp, d: 0 }], b: cerdas(), fin: 0 };
    trazos.push(actual);
    if (trazos.length > 120) trazos.shift();
    html.classList.add('forma-lapiz--dibujando');
    pedir();
  }
  function mover(e) {
    if (!actual) return;
    var p = actual.p, q = p[p.length - 1];
    var d = Math.hypot(e.pageX - q.x, e.pageY - q.y);
    if (d < 2) return;
    var v = d / Math.max(1, e.timeStamp - q.t);                          // px por ms
    var w = ANCHO * Math.min(1.25, Math.max(0.35, 1.25 - v * 0.3));     // lento = grueso, rápido = fino
    p.push({ x: e.pageX, y: e.pageY, w: q.w * 0.8 + w * 0.2, t: e.timeStamp, d: q.d + d });
    pedir();
  }
  function arriba() {
    if (!actual) return;
    actual.fin = performance.now();
    actual = null;
    html.classList.remove('forma-lapiz--dibujando');
    pedir();
  }

  function aplicar() {
    activo = mq.matches;
    html.classList.toggle('forma-lapiz', activo);
    if (activo && !canvas) crear();
    if (canvas) canvas.style.display = activo ? '' : 'none';
    if (!activo) { trazos = []; actual = null; }
  }

  document.addEventListener('mousedown', abajo);
  document.addEventListener('mousemove', mover, { passive: true });
  document.addEventListener('mouseup', arriba);
  window.addEventListener('blur', arriba);
  window.addEventListener('scroll', function () { if (activo && trazos.length) pedir(); }, { passive: true });
  window.addEventListener('resize', function () { if (canvas) medir(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && trazos.length) { trazos = []; pedir(); } });
  if (mq.addEventListener) mq.addEventListener('change', aplicar); else mq.addListener(aplicar);
  aplicar();
})();
